// Directus names for the deliverables collection and its M2M junctions.
// Defaults generated by Directus; update here if the junctions are named differently.
export const COLLECTION = "deliverables";

export const SKILLS_FIELD = "skills";
export const SKILLS_JUNCTION_KEY = "skill";

export const FILES_FIELD = "files";
export const FILES_JUNCTION_KEY = "file";
